import {
    Component, ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ProjectRequestParams, ProjectRequestTable } from '@app/interfaces/lm/project-request';
import { Tab } from '@app/interfaces/lm/system';
import { TaskDetail, TaskHardwareReservationIn } from '@app/interfaces/lm/task';
import { TimeSegmentModify } from '@app/interfaces/lm/task-hardware';
import { CalendarTableData, HardwareReservation } from '@app/interfaces/reservation/hardware-reservation';
import { ResourceInstancesField } from '@app/interfaces/rm/resource-instances';
import { ResourcesTab } from '@app/interfaces/rm/resources';
import { SelectOption } from '@app/interfaces/sys/dict';
import { STColumn, STData, STScroll } from '@app/interfaces/sys/st';
import resources from '@app/modules/product/rm/resource/components/other-resources/resources';
import { EditReservationComponent } from '@app/shared/components/table-calendar/component/edit-reservation/edit-reservation.component';
import { ProjectRequestService } from '@services/lm/project-request.service';
import { TaskHardwareService } from '@services/lm/task-hardware.service';
import { TaskHumanService } from '@services/lm/task-human.service';
import { ResourcesService } from '@services/rm/resources.service';
import { SettingsService } from '@services/sys/settings.service';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzTableComponent } from 'ng-zorro-antd/table';
interface Cell {
    date: string;
    task: TaskHardwareReservationIn[];
    disabled: boolean;
    isSomeHour: boolean;
    isWeekend: boolean;
    isDifferentTask: boolean;
    hasConflict: boolean;
}

interface ResourceItem {
    checked?: boolean;
    id: number | string;
    name: string;
    dateList: Cell[];
}

@Component({
    selector: 'app-table-calendar',
    templateUrl: './table-calendar.component.html',
    styleUrls: ['./table-calendar.component.less'],
})
export class TableCalendarComponent implements OnInit, OnChanges {
    @ViewChild('editDialog') editDialog!: EditReservationComponent;
    @ViewChild('calendarTable') calendarTableEl!: ElementRef;
    @ViewChild('table', { static: false }) table!: NzTableComponent<any>;
    @Input() resourceType = 'hardware';
    @Input() currentResourceName = 'CHAMBER';
    @Input() start = dayjs().startOf('month').valueOf();
    @Input() end = dayjs().endOf('month').valueOf();
    @Input() calendarTableData: CalendarTableData = {
        resources: [],
        reservations: [],
        reservationInfo: []
    };
    resources!: any[];
    reservations!: Array<HardwareReservation>;
    reservationInfo!: TaskHardwareReservationIn[];
    @Input() canEdit = false;
    @Input() taskDetail!: TaskDetail;
    @Input() projectResources!: {
        id: string;
        name: string;
        start: number;
        end: number;
    }[];
    @Input() needRangeSwitch = false;
    @Input() needCheckBox = false;
    @Input() fromTaskDashboard = false;
    @Input() highlightId!: string;
    @Input() fromResourceCalendar = false;
    @Output() submitSuccess = new EventEmitter();
    @Output() changeRange = new EventEmitter();
    @Output() changeColumns = new EventEmitter();

    nzScroll: STScroll = {};
    dateList: string[] = [];
    tableData: ResourceItem[] = [];
    loading = false;
    selectDate: string[] = [];
    startCell = '';
    tabs: Tab[] = [
        {
            id: 'day',
            name: 'Daily',
        },
        {
            id: 'month',
            name: 'Monthly',
        },
    ];

    calendarMode = 'month';
    currentDay = '';

    realStartTime = '';
    realEndTime = '';
    currentAction = '';
    allChecked = false;
    indeterminate = false;
    taskRequests: ProjectRequestTable[] = [];
    requestLoading = false;
    hasEyes = false;
    menuColumns: SelectOption[] = [];
    originMenuColumns: SelectOption[] = [];
    displayedColumns: SelectOption[] = [];
    menuVisible = false;
    allColumnsChecked = false;
    allColumnsIndeterminate = false;
    applyLoading = false;
    otherResourcesArr: string[] = [];
    hasEyesResources = ['CHAMBER', 'PHYSICAL_SERVER', 'SWITCH_ROUTER', 'BBU', 'RF_SWITCH_SPLITTER', 'SHIELD_CHAMBER_BOX'];
    menuLoading = false;
    allColumns: STColumn[] = [];
    cellWidth = 60;
    calendarLoading = false;

    constructor(private settingService: SettingsService,
                private taskHardwareService: TaskHardwareService,
                private message: NzMessageService,
                private modal: NzModalService,
                private taskHumanService: TaskHumanService,
                private projectRequestService: ProjectRequestService,
                private resourcesService: ResourcesService,
                private router: Router) {
    }

    get currentIndex(): number {
        if (this.calendarMode?.length) {
            return this.tabs.findIndex((item) => item.id === this.calendarMode);
        }
        return 0;
    }

    async ngOnInit(): Promise<void> {
        this.otherResourcesArr = resources?.data.map(item => item.type);
        this.setScroll();
    }

    @HostListener('window:resize')
    _resize(): void {
        this.setScroll();
        this.setTableCell();
    }

    setScroll(): void {
        this.settingService.setLayout();
        const { y } = this.settingService.layout;
        const height = this.calendarTableEl?.nativeElement?.clientHeight;
        this.nzScroll = {
            x: '300px',
            y: `${height ? height - 109 : y - 68}px`,
        };
    }

    getCapacityDate(): number {
        const tableEl = this.table?.nzTableInnerScrollComponent?.tableBodyElement;
        let calendarWidth = tableEl?.nativeElement?.offsetWidth;
        const data = document.querySelectorAll('.ant-table-thead .ant-table-cell-fix-left');
        const cell = document.getElementsByClassName('date-th');
        this.cellWidth = (cell[0] as any)?.offsetWidth || 60;
        data?.forEach((item: any) => {
            calendarWidth -= item?.offsetWidth || 0;
        });
        const capacityDateNum = Math.floor(calendarWidth / this.cellWidth);
        return (this.calendarMode === 'month' ? capacityDateNum : capacityDateNum + 1) || 0;
    }

    updateAllChecked(): void {
        this.indeterminate = false;
        if (this.allChecked) {
            this.tableData = this.tableData.map(item => ({
                ...item,
                checked: true
            }));
        } else {
            this.tableData = this.tableData.map(item => ({
                ...item,
                checked: false
            }));
        }
    }

    getDayRange(): string {
        const start = dayjs(this.start).startOf('d').valueOf();
        const end = dayjs(this.end).startOf('d').valueOf();
        if (start !== end && this.fromResourceCalendar) {
            return dayjs(this.start).format('YYYY-MM-DD') + ' - ' + dayjs(this.end).format('YYYY-MM-DD h A');
        } else {
            return dayjs(this.currentDay).format('YYYY-MM-DD');
        }
    }

    getValueByPath(data: STData, key: string, column: STColumn, i: number): any {
        let temp: any = data;
        if (key) {
            const fields = data?.resourceInstance?.fields;
            const itemData = fields?.find((item: ResourceInstancesField) => item?.resourceDefinitionFieldTitle === key);
            if (itemData) {
                temp = itemData ? itemData.value || '' : '';
            } else {
                for (const p of key.split('.')) {
                    temp = temp[p] || '';
                }
            }
        }
        if (column?.format) {
            temp = column.format(data, column, i);
        }
        return this.formatHtml(temp);
    }

    formatHtml(value: string): string {
        return value?.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    changeCheckOne(): void {
        this.indeterminate = this.tableData.some((item) => item.checked);
        this.allChecked = this.tableData.every((item) => item.checked);
        if (this.allChecked) {
            this.indeterminate = false;
        }
    }

    setTableCell(): void {
        const tableCell = document.getElementsByClassName('half-cell');
        if (tableCell.length === 0) {
            return;
        }
        // tslint:disable-next-line:forin
        for (const tableCellKey in tableCell) {
            const cellWidth = tableCell[tableCellKey]?.parentElement?.clientWidth;
            const cellHeight = tableCell[tableCellKey]?.parentElement?.clientHeight;
            if (!cellWidth || !cellHeight) {
                return;
            }
            const borderRightWidth = cellWidth / 2;
            const borderTopWidth = cellHeight / 2;
            tableCell[tableCellKey].setAttribute('style',
                `border-right-width: ${borderRightWidth}px;
                       border-left-width: ${borderRightWidth}px;
                       border-top-width: ${borderTopWidth}px;
                       border-bottom-width: ${borderTopWidth}px;`);
        }
    }

    formatTimeRange(): Promise<void> {
        this.calendarLoading = true;
        return new Promise((resolve) => {
            const date = this.currentDay ? new Date(this.currentDay) : new Date();
            const lastDate = dayjs(date).endOf('month');
            const unit = this.calendarMode === 'month' ? 'month' : 'day';
            const currentDay = unit === 'month' ? this.start : this.currentDay;
            const isSame = dayjs(currentDay).startOf(unit).valueOf() === dayjs().startOf(unit).valueOf();
            if (!isSame) {
                this.calendarLoading = false;
                resolve();
                return;
            } else {
                setTimeout(() => {
                    const capacityDateNum = this.getCapacityDate();
                    // current day or current hour number
                    const countUnit = this.calendarMode === 'month' ? 'date' : 'hour';
                    const currentCount = dayjs().get(countUnit);
                    // one month has day number or one day has 24 hours
                    const allCount = this.calendarMode === 'month' ? dayjs(lastDate).get('date') : 24;
                    const isOutOfRange = currentCount + capacityDateNum > allCount;
                    if (!isOutOfRange) {
                        resolve();
                        return;
                    }
                    const addUnit = this.calendarMode === 'month' ? 'day' : 'hour';
                    this.end = dayjs().add(capacityDateNum, addUnit).endOf(addUnit).valueOf();
                    this.calendarLoading = false;
                    resolve();
                }, 200);
            }
        });
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        const { currentResourceName } = changes;
        if (this.taskDetail) {
            const { startTime, dueTime } = this.taskDetail;
            this.start = startTime;
            this.end = dueTime;
        }
        this.dateList = await this.getDateList();
        if (!this.dateList || this.dateList.length === 0) {
            return;
        }
        if (this.fromTaskDashboard) {
            await this.getTaskRequest();
        }
        if (currentResourceName) {
            this.hasEyes = this.hasEyesResources.includes(this.currentResourceName);
            this.getMenuColumns(true);
        }
        await this.getResourceList();
    }

    async getTaskRequest(): Promise<void> {
        try {
            if (!this.taskDetail) {
                return ;
            }
            let params: ProjectRequestParams = {
                page: 0,
                size: 99999,
                taskId: this.taskDetail.id,
                status: 'PENDING',
            };
            params = this.resourceType === 'human' ? {...params, humanResourceRequest: true} : {...params, hardwareResourceRequest: true};
            this.requestLoading = true;
            const { content } = await this.projectRequestService.find(params);
            this.taskRequests = content;
        } finally {
            this.requestLoading = false;
        }
    }

    async getDateList(): Promise<string[]> {
        if (this.fromResourceCalendar) {
            await this.formatTimeRange();
        }
        const start = this.start;
        const end = this.end;
        if (this.calendarMode === 'month') {
            if (this.needRangeSwitch) {
                this.realStartTime = dayjs(start).format('YYYY-MM-DD');
                this.realEndTime = dayjs(end).format('YYYY-MM-DD');
            } else {
                this.realStartTime = dayjs(start).subtract(2, 'd').format('YYYY-MM-DD');
                this.realEndTime = dayjs(end).add(2, 'd').format('YYYY-MM-DD');
            }

            const diff = dayjs(this.realEndTime).diff(this.realStartTime, 'days');
            const calendarRange = [];
            for (let i = 0; i <= diff; i++) {
                calendarRange.push(dayjs(this.realStartTime).add(i, 'd').format('YYYY-MM-DD'));
            }
            return calendarRange;
        } else {
            const calendarRange = [];
            const diff = this.fromResourceCalendar ? dayjs(this.end).diff(this.start, 'hour') : 24;
            for (let i = 0; i < diff; i++) {
                calendarRange.push(dayjs(this.currentDay).add(i, 'hour').format('YYYY-MM-DD HH:mm:ss'));
            }
            return calendarRange;
        }
    }

    getResourceList(): void {
        this.calendarLoading = true;
        dayjs.extend(isBetween);
        const { resources, reservations, reservationInfo } = this.calendarTableData;
        this.resources = resources;
        // console.log('resources', resources);
        this.reservations = reservations as HardwareReservation[];
        if (reservationInfo) {
            this.reservationInfo = reservationInfo;
        }
        this.tableData = !this.resources || this.resources.length === 0 ? [] : this.resources.map((resourceItem) => {
            const reservationData = this.reservations.filter((reservationItem) =>
                reservationItem?.hardwareId.toString() === resourceItem.hardwareId.toString());
            let dateList = [];
            dateList = this.dateList.map((dateItem) => {
                const reservationInfos: TaskHardwareReservationIn[] = [];
                reservationData?.forEach((data) => {

                    data?.timeSegments.forEach((rangeItem) => {
                        const rangeStart = dayjs(rangeItem.startTime).format('YYYY-MM-DD HH:mm:ss');
                        const rangeEnd = dayjs(rangeItem.endTime).format('YYYY-MM-DD HH:mm:ss');

                        const rangeIncludeDate = dayjs(dateItem).isBetween(rangeStart, rangeEnd) ||
                            (this.calendarMode === 'day' && (this.isSameDay(dateItem, rangeStart, 'YYYY-MM-DD HH') || this.isSameDay(dateItem, rangeEnd, 'YYYY-MM-DD HH'))) ||
                            (this.calendarMode === 'month' && (this.isSameDay(dateItem, rangeStart) || this.isSameDay(dateItem, rangeEnd)));
                        // @ts-ignore
                        if (!rangeIncludeDate) {
                            return;
                        }
                        const reservation = this.reservationInfo?.find((item) => data.reservationId === (this.resourceType === 'human' ? item.humanReservation : item.hardwareReservation));
                        let isSomeHour = false;
                        if (this.calendarMode === 'month') {
                            const dateItemStart = dayjs(dateItem).format('YYYY-MM-DD 00:00:00');
                            const dateItemEnd = dayjs(dateItem).format('YYYY-MM-DD 23:00:00');
                            isSomeHour = dayjs(rangeItem.startTime).isBetween(dateItemStart, dateItemEnd) || dayjs(rangeItem.endTime).isBetween(dateItemStart, dateItemEnd);
                        }

                        reservationInfos.push({
                            ...(reservation || {}),
                            isSomeHour,
                        });
                    });
                });
                const weekNumber = dayjs(dateItem).day();
                const allIsSomeHour = reservationInfos.length > 0 && reservationInfos.every(item => item.isSomeHour);
                const disabledFormat = this.calendarMode === 'month' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss';
                const isDifferentTask = reservationInfos.length > 0 && this.taskDetail?.id ? reservationInfos.every(item => item.id !== this.taskDetail.id) : false;
                return {
                    date: dateItem,
                    task: reservationInfos,
                    isSomeHour: allIsSomeHour,
                    disabled: dayjs(dateItem).isBefore(dayjs().format(disabledFormat)) || dayjs(dateItem).isAfter(this.end) || dayjs(dateItem).isBefore(dayjs(this.start).format(disabledFormat)),
                    isWeekend: weekNumber === 6 || weekNumber === 0,
                    isDifferentTask,
                    hasConflict: !isDifferentTask && this.hasConflictTime(reservationInfos, resourceItem.hardwareId),
                    hasRequest: !!this.hasRequestTime(dateItem, resourceItem.hardwareId),
                };
            });
            return {
                ...resourceItem,
                ...resourceItem.properties,
                id: resourceItem.hardwareId,
                name: resourceItem.name,
                dateList,
            };
        });
        this.setTableCell();
        setTimeout(() => {
            this.resetTableScroll();
            this.calendarLoading = false;
        }, 200);
    }

    resetTableScroll(): void {
        const tableEl = this.table?.nzTableInnerScrollComponent?.tableBodyElement;
        const unit = this.calendarMode === 'month' ? 'month' : 'day';
        const currentDay = unit === 'month' ? this.start : this.currentDay;
        const isSame = dayjs(currentDay).startOf(unit).valueOf() === dayjs().startOf(unit).valueOf();
        const todayDate = dayjs().get('date');
        const startDate = dayjs(this.dateList[0]).get('date');
        const diffDate = todayDate - startDate;
        const beforeCurrentCount = unit === 'month' ? (diffDate < 0 ? 0 : diffDate) : dayjs().get('hour') + 1;
        tableEl!.nativeElement!.scrollLeft = isSame ? beforeCurrentCount * this.cellWidth : 0;
    }

    hasRequestTime(date: string, hardwareId: string): ProjectRequestTable | undefined {
        const startTime = dayjs(date).startOf('d').valueOf();
        const endTime = dayjs(date).endOf('d').valueOf();
        const res = this.resourceType === 'human' ? this.taskRequests?.find((item) => item.humanId === hardwareId.toString() && !(item.endTime <= startTime || item.startTime >= endTime)) :
            this.taskRequests?.find((item) => item.hardwareId === hardwareId && !(item.endTime <= startTime || item.startTime >= endTime));
        return res;
    }

    toRequest(row: ResourceItem): void {
        if (!row.id) {
            return;
        }
        this.router.navigate(['/resource-request/pending'], {
            queryParams: this.resourceType === 'human' ? {
                humanId: row.id,
            } : {
                hardwareId: row.id,
            }
        });
    }

    hasConflictTime(info: TaskHardwareReservationIn[], hardwareId: string): boolean {
        if (info.length === 0 || this.reservations.length === 0) {
            return false;
        }
        if (this.calendarMode === 'day' && info.length > 1) {
            return true;
        }
        const timeSegments: {
            startTime: number;
            endTime: number;
            duration: number;
        }[] = [];
        const reservationIds = info.map(item => (this.resourceType === 'human' ? item.humanReservation : item.hardwareReservation)).filter(item => item !== undefined);
        this.reservations.forEach(res => {
            if (!(res.hardwareId.toString() === hardwareId.toString() && reservationIds.includes(res.reservationId))) {
                return;
            }
            timeSegments.push(...res.timeSegments);
        });
        let hasConflict = false;
        for (let index = 0; index < timeSegments.length; index++) {
            const item = timeSegments[index];
            hasConflict = timeSegments.some((i, cIndex) => cIndex !== index &&
                ((item.startTime >= i.startTime && item.startTime <= i.endTime) || (item.endTime >= i.startTime && item.endTime <= i.endTime)),
            );
            if (hasConflict) {
                break;
            }
        }
        return hasConflict;
    }

    mouseDown(event: MouseEvent, data: ResourceItem, cell: Cell): void {
        // event.preventDefault();
        if (cell.disabled || !this.canEdit) {
            return;
        }
        const cellKey = data.id + '_' + cell.date;
        this.selectDate.push(cellKey);
        this.startCell = cellKey;
        if (cell.task.length > 0 && !cell.isDifferentTask) {
            this.currentAction = 'release';
        } else {
            this.currentAction = 'reserve';
        }
    }

    mouseEnter(event: MouseEvent, data: ResourceItem, cell: Cell): void {
        event.preventDefault();
        if (this.selectDate.length === 0 || cell.disabled) {
            return;
        }
        const resourceId = this.startCell.split('_')[0];
        const startCellDate = this.startCell.split('_')[1];
        let startDate = startCellDate;
        let endDate = cell.date;
        if (dayjs(startCellDate).isAfter(cell.date)) {
            startDate = cell.date;
            endDate = startCellDate;
        }

        const diffUnit = this.calendarMode === 'day' ? 'hour' : 'day';
        const diffCell = dayjs(endDate).diff(startDate, diffUnit);
        if (diffCell === 0) {
            this.selectDate = [resourceId + '_' + startDate];
            return;
        }
        this.selectDate = [
            resourceId + '_' + startDate,
            ...new Array(diffCell).fill(null).map((_, index) => {
                let date = '';
                if (this.calendarMode === 'day') {
                    date = dayjs(startDate).add(index + 1, diffUnit).format('YYYY-MM-DD HH:mm:ss');
                } else {
                    date = dayjs(startDate).add(index + 1, diffUnit).format('YYYY-MM-DD');
                }
                return resourceId + '_' + date;
            }),
        ];
    }

    async mouseUp(event: MouseEvent): Promise<void> {
        event.preventDefault();
        if (!this.startCell) {
            return;
        }
        const data = this.selectDate;
        // this.allSelectDate.push(...this.selectDate);
        this.modal.confirm({
            nzTitle: `Do you want to ${this.currentAction} this reservation!`,
            nzOkText: 'Yes',
            nzCancelText: 'No',
            nzOkType: 'primary',
            nzOkDanger: true,
            nzStyle: { top: '40vh' },
            nzOnOk: async () => {
                await this.editReservation(data);
            },
            nzOnCancel: () => {
                this.clearCell();
            },
        });
    }

    clearCell(): void {
        this.selectDate = [];
        this.startCell = '';
    }

    getTimeValue(time: string, dateType: string = 'start'): number {
        if (dateType === 'start') {
            const maxStartTime = dayjs(this.start).isBefore(dayjs()) ? dayjs().valueOf() : this.start;
            const selectTime = dayjs(time).startOf('d').valueOf();
            const start = dayjs(maxStartTime).isBefore(selectTime) ? selectTime : maxStartTime;
            return dayjs(start).get('minute') >= 30 ? dayjs(start).add(1, 'h').startOf('h').valueOf() : dayjs(start).startOf('h').valueOf();
        } else {
            const end = dayjs(time).endOf('d').valueOf();
            return dayjs(this.end).isBefore(end) ? this.end : end;
        }
    }

    async editReservation(selectDate: string[]): Promise<void> {
        try {
            this.loading = true;
            const hardwareId = selectDate[0].split('_')[0];
            const start = selectDate[0].split('_')[1];
            const end = selectDate[selectDate.length - 1].split('_')[1];
            const addedRange = this.calendarMode === 'month' ? {
                startTime: this.getTimeValue(start),
                endTime: this.getTimeValue(end, 'end'),
            } : {
                startTime: dayjs(start).valueOf(),
                endTime: dayjs(end).endOf('hour').valueOf(),
            };
            let timeSegmentModify: TimeSegmentModify = {} as TimeSegmentModify;
            if (this.currentAction === 'release') {
                timeSegmentModify = {
                    reserve: [],
                    release: [addedRange],
                };
            } else {
                timeSegmentModify = {
                    reserve: [addedRange],
                    release: [],
                };
            }
            if (this.resourceType === 'human') {
                const query = {
                    task: this.taskDetail.id,
                    humanReservationModifyList: [
                        {
                            humanId: hardwareId,
                            timeSegmentModify,
                        },
                    ],
                };
                await this.taskHumanService.modify(query);
            } else {
                const params = {
                    task: this.taskDetail.id,
                    hardwareReservationModifyList: [
                        {
                            hardwareId,
                            timeSegmentModify,
                        },
                    ],
                };
                await this.taskHardwareService.modify(params);
            }
            const type = this.resourceType === 'human' ? 'Human resource' : 'The resource';
            const action = this.currentAction === 'release' ? 'released' : 'reserved';
            this.message.success(`${type} ${action} successfully`);
            this.submitSuccess.emit();
        } finally {
            this.loading = false;
            this.clearCell();
        }
    }

    getColor(cell: Cell): string {
        const level = cell.task.length;
        const isPastDayColor = cell.disabled ? ' disabled-color' : '';
        return 'cellColor' + (level > 5 ? 5 : level) + ' un-select' + isPastDayColor;
    }

    getHeaderColor(dateItem: string): string {
        const disabledFormat = this.calendarMode === 'month' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss';
        const disabled = dayjs(dateItem).isBefore(dayjs().format(disabledFormat)) || dayjs(dateItem).isAfter(this.end) || dayjs(dateItem).isBefore(dayjs(this.start).format(disabledFormat));
        if (disabled) {
            return ' disabled-color';
        }

        const weekNumber = dayjs(dateItem).day();
        if (weekNumber === 6 || weekNumber === 0) {
            return 'weekend-cell';
        }
        return '';
    }

    tableMouseLeave(): void {
        this.selectDate = [];
    }

    edit(row: ResourceItem): void {
        const currentTaskReservationInfo = this.reservationInfo.find((infoItem) => infoItem.id === this.taskDetail.id);
        const editData = currentTaskReservationInfo ? this.reservations.filter((item) => item.hardwareId.toString() === row.id.toString() && (this.resourceType === 'human' ? currentTaskReservationInfo.humanReservation : currentTaskReservationInfo.hardwareReservation) === item.reservationId) : [];
        this.editDialog.open(row.id as string, editData, row.name);
    }

    changeData(): void {
    }

    refresh(): void {
        this.submitSuccess.emit();
    }

    async changeDayView(date: string): Promise<void> {
        if (this.calendarMode === 'day') {
            return;
        }
        this.calendarMode = 'day';
        this.currentDay = dayjs(date).format('YYYY-MM-DD');
        this.dateList = await this.getDateList();
        this.getResourceList();
    }

    async changeView(item: Tab): Promise<void> {
        dayjs.extend(isSameOrBefore);
        dayjs.extend(isSameOrAfter);
        this.calendarMode = item.id;
        const end = dayjs(this.end).format('YYYY-MM-DD');
        const start = dayjs(this.start).format('YYYY-MM-DD');
        const isBeforeEnd = dayjs().isSameOrBefore(end);
        const isAfterStart = dayjs().isSameOrAfter(start);
        this.currentDay = isAfterStart && isBeforeEnd ? dayjs().format('YYYY-MM-DD') : dayjs(this.start).format('YYYY-MM-DD');
        if (this.needRangeSwitch) {
            let range: number[] = [];
            if (this.calendarMode === 'month') {
                range = [dayjs(this.currentDay).startOf('month').valueOf(), dayjs(this.currentDay).endOf('month').valueOf()];
            } else {
                range = [dayjs(this.currentDay).startOf('day').valueOf(), dayjs(this.currentDay).endOf('day').valueOf()];
            }
            this.changeRange.emit(range);
        } else {
            const start = dayjs(new Date()).isBetween(dayjs(this.start), dayjs(this.end)) ? dayjs(new Date()).startOf('day').valueOf() : this.start;
            this.currentDay = dayjs(start).format('YYYY-MM-DD');
            this.dateList = await this.getDateList();
            this.getResourceList();
        }
    }

    async changeDay(type: string): Promise<void> {
        if (type === 'pre') {
            this.currentDay = dayjs(this.currentDay).subtract(1, 'day').format('YYYY-MM-DD');
        } else {
            this.currentDay = dayjs(this.currentDay).add(1, 'day').format('YYYY-MM-DD');
        }
        if (this.needRangeSwitch) {
            const range: number[] = [dayjs(this.currentDay).startOf('day').valueOf(), dayjs(this.currentDay).endOf('day').valueOf()];
            this.changeRange.emit(range);
        } else {
            this.dateList = await this.getDateList();
            this.getResourceList();
        }
    }

    changeMonth(type: string): void {
        let startTime;
        let endTime;
        if (type === 'pre') {
            startTime = dayjs(this.start).subtract(1, 'month').startOf('month');
            endTime = dayjs(this.start).subtract(1, 'month').endOf('month');
        } else {
            startTime = dayjs(this.start).add(1, 'month').startOf('month');
            endTime = dayjs(this.start).add(1, 'month').endOf('month');
        }
        this.start = dayjs(startTime).valueOf();
        this.end = dayjs(endTime).valueOf();
        this.changeRange.emit([this.start, this.end]);
    }

    isSameDay(date1: string, date2: string | number, formatString: string = 'YYYY-MM-DD'): boolean {
        const day1 = dayjs(date1).format(formatString);
        const day2 = dayjs(date2).format(formatString);
        return dayjs(day1).isSame(day2);
    }

    getDisabled(type: string): boolean {
        if (this.needRangeSwitch) {
            return false;
        }
        if (type === 'pre') {
            return !dayjs(this.currentDay).isAfter(this.realStartTime);
        }

        if (type === 'next') {
            return !dayjs(this.currentDay).isBefore(this.realEndTime);
        }

        return false;
    }

    hasTaskInfo(cell: Cell): boolean {
        return cell?.task?.length > 0 && cell.task.some(item => item.name);
    }

    getKeepResource(): string[] {
        const arr = this.tableData?.filter((item) => item.checked);
        return arr && arr.length > 0 ? arr.map((item) => item.id) as string[] : [] as string[];
    }

    changeMenuVisible(visible: boolean): void {
        this.menuVisible = visible;
        if (visible) {
            this.getMenuColumns();
        } else {
            this.menuColumns = [...this.originMenuColumns];
        }
    }

    async getMenuColumns(init: boolean = false): Promise<void> {
        try {
            const otherResourcesTab = resources.data.find((item) => item.type === this.currentResourceName) as ResourcesTab;
            if (!this.hasEyes) {
                this.allColumns = [];
                this.menuColumns = [];
                this.displayedColumns = [];
                return;
            }
            this.menuLoading = true;
            if (init) {
                const { columns } = await this.resourcesService.getResourceAllColumns(otherResourcesTab?.tableColumns || [], this.currentResourceName);
                this.allColumns = [...columns];
            }
            const data = localStorage.getItem(`${this.currentResourceName}_Display`);
            const selectedArr = data ? JSON.parse(data) : [];
            this.menuColumns = this.allColumns?.filter((item: STColumn) => !(item.notShowInCheck || item.index === 'name'))?.map((column: STColumn) => {
                return {
                    ...column,
                    value: column.index as string,
                    label: column.title as string,
                    checked: selectedArr?.includes(column.index as string)
                };
            });
            this.originMenuColumns = JSON.parse(JSON.stringify(this.menuColumns));
            this.displayedColumns = this.menuColumns?.filter(item => item.checked);
            this.updateSingleColumnChecked();
        } finally {
            this.menuLoading = false;
        }
    }

    updateSingleColumnChecked(): void {
        if (this.menuColumns.every(item => !item.checked)) {
            this.allColumnsChecked = false;
            this.allColumnsIndeterminate = false;
        } else if (this.menuColumns.every(item => item.checked)) {
            this.allColumnsChecked = true;
            this.allColumnsIndeterminate = false;
        } else {
            this.allColumnsIndeterminate = true;
        }
    }

    updateColumnChecked(): void {
        this.allColumnsIndeterminate = false;
        if (this.allColumnsChecked) {
            this.menuColumns = this.menuColumns.map(item => ({
                ...item,
                checked: true
            }));
        } else {
            this.menuColumns = this.menuColumns.map(item => ({
                ...item,
                checked: false
            }));
        }
    }

    apply(): void {
        const selectedArr = this.menuColumns.filter(item => item.checked)?.map(dataItem => dataItem.value);
        if (selectedArr.length > 3) {
            this.message.warning('At most three columns to show');
            return ;
        }
        const displayedValue = this.displayedColumns?.map(item => item.value);
        const newData = JSON.stringify(selectedArr);
        const oldData = JSON.stringify(displayedValue);
        this.menuVisible = false;
        localStorage.setItem(`${this.currentResourceName}_Display`, newData);
        if (newData !== oldData) {
            this.changeColumns.emit(true);
        }
        this.getMenuColumns();
        this.resetTableScroll();
    }

}
